import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SessionService, UserSession } from '../services/session.service';

@Component({
  selector: 'app-session-management',
  templateUrl: './session-management.component.html',
  styleUrls: ['./session-management.component.scss']
})
export class SessionManagementComponent implements OnInit, OnDestroy {

  sessions: UserSession[] = [];
  loading = false;
  me = window.localStorage.getItem('loggedInUser') || '';

  private refreshTimer: any = null;

  constructor(
    private sessionService: SessionService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.load();
    this.refreshTimer = setInterval(() => this.load(), 30000);
  }

  ngOnDestroy(): void {
    if (this.refreshTimer) { clearInterval(this.refreshTimer); }
  }

  load(): void {
    this.loading = true;
    this.sessionService.getActive().subscribe({
      next: (list) => { this.sessions = list || []; this.loading = false; },
      error: () => { this.loading = false; }
    });
  }

  endSession(s: UserSession): void {
    this.sessionService.revoke(s.sessionId).subscribe({
      next: () => {
        this.snackBar.open(`Session ended for ${s.employeeName || s.employeeId}.`, 'Close', { duration: 4000 });
        this.load();
      },
      error: () => this.snackBar.open('Failed to end session.', 'Close', { duration: 4000 })
    });
  }

  endEmployeeSessions(s: UserSession): void {
    this.sessionService.revokeByEmployee(s.employeeId).subscribe({
      next: (res) => {
        this.snackBar.open(`Ended ${res?.revoked ?? 0} session(s) for ${s.employeeName || s.employeeId}.`, 'Close', { duration: 4000 });
        this.load();
      },
      error: () => this.snackBar.open('Failed to end sessions.', 'Close', { duration: 4000 })
    });
  }

  endAll(): void {
    this.sessionService.revokeAll().subscribe({
      next: (res) => {
        this.snackBar.open(`Ended ${res?.revoked ?? 0} session(s) — including yours. You will be logged out.`, 'Close', { duration: 5000 });
      },
      error: () => this.snackBar.open('Failed to end sessions.', 'Close', { duration: 4000 })
    });
  }

  isMe(s: UserSession): boolean {
    return s.employeeId === this.me;
  }
}
